/**
 *  @author Eugene Terentev <eugene@terentev.net>
 */
import './_script.js';